import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { quoteService } from '../services/quoteService';
import { Quote } from '@brovicms/models';
import QuoteForm from '../components/quotes/QuoteForm';

const QuoteUpsert = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [quote, setQuote] = useState<Quote | undefined>(undefined);
  const [loading, setLoading] = useState(!!id);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (id) {
      fetchQuote();
    }
  }, [id]);

  const fetchQuote = async () => {
    try {
      setLoading(true);
      const result = await quoteService.getQuote(id!);
      if (result.success && result.data) {
        setQuote(result.data);
      } else {
        navigate('/quotes');
      }
    } catch (error) {
      console.error('Error fetching quote:', error);
      navigate('/quotes');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (success: boolean) => {
    if (success) {
      navigate('/quotes');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-96">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading quote...</p>
        </div>
      </div>
    );
  }

  return (
    <QuoteForm 
      quote={quote}
      onSuccess={handleSubmit}
      loading={saving}
    />
  );
};

export default QuoteUpsert;
